import RoleRestClient from "./RoleRestClient";

const roleRestClient = new RoleRestClient();

const getAllRoles = async () => {
    const response = await roleRestClient.rolesApi().getAllRealmRoles();
    return response.data;
};

const getUserRoles = async (userId) => {
    const response = await roleRestClient.rolesApi().getUserRoles(userId);
    return response.data;
};

const assignRole = async (userId, roleName) => {
    const response = await roleRestClient.rolesApi().assignRoleToUser(userId, roleName);
    return response.data;
};

const removeRole = async (userId, roleName) => {
    const response = await roleRestClient.rolesApi().removeRoleFromUser(userId, roleName);
    return response.data;
};

const roleRestService = {
    getAllRoles,
    getUserRoles,
    assignRole,
    removeRole
};

export default roleRestService;
